import * as React from "react";
import { DentalInfo } from "../patient-portal/DentalInfo";
import DentalInformationItemsList from "./DentalInformationItemsList";

export default function PatientDentalInformationPanel({
  dentalInformation,
  title,
}: {
  dentalInformation?: DentalInfo;
  title: string;
}) {
  return (
    <div className="panel">
      <div className="panel-title h-flex space-between no-wrap">
        <div>{title}</div>
      </div>
      {dentalInformation ? (
        <DentalInformationItemsList dentalInfo={dentalInformation} fullDetails={true} />
      ) : (
        <div className="centered">
          <span className="no-information-message">
            {i18n["Page.Patient.FullDetails.Information.NotFilled"]}
          </span>
        </div>
      )}
    </div>
  );
}
